var _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    fill: "#9DA6B4",
    stroke: "#9DA6B4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3735_20885",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 32,
    height: 32
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16,
    fill: "#CED5DE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3735_20885)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6002 10.7447C10.6002 7.12972 13.4656 4.19922 17.0002 4.19922C20.5348 4.19922 23.4002 7.12972 23.4002 10.7447C23.4002 14.3596 20.5348 17.2901 17.0002 17.2901C13.4656 17.2901 10.6002 14.3596 10.6002 10.7447ZM17.0002 14.6719C14.8794 14.6719 13.1602 12.9557 13.1602 10.7447C13.1602 12.9589 14.8794 14.6719 17.0002 14.6719C19.121 14.6719 20.8402 12.9136 20.8402 10.7447C20.8402 12.9117 19.121 14.6719 17.0002 14.6719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2002 31.6901C4.2002 24.4602 9.93095 19.5814 17.0002 19.5814C24.0694 19.5814 29.8002 24.4602 29.8002 31.6901V32.9992H4.2002V31.6901ZM6.83942 30.381H27.161C21.8505 30.381 21.9021 30.381 16.6802 30.381C11.4583 30.381 12.5225 30.381 6.83942 30.381Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.e717af78a028bd80072fb0d7196ca38c.svg";
export { ForwardRef as ReactComponent };